<app-wizard
    title="{{ 'SETUP.TITLE.WELCOME_TO_APP' | translate: { appName } }}"
    (completed)="onSetupWizardCompleted()"
>
    <app-welcome-wizard-step #step />
    <app-site-connect-wizard-step #step />
    <app-enter-security-pin-wizard-step #step />
    <app-load-master-data-wizard-step #step />
</app-wizard>
